import React, { useState, useEffect } from "react";
import "pure-react-carousel/dist/react-carousel.es.css";

import "./slider.css";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from "pure-react-carousel";

const TestSlider = (props) => {
  // Similar to componentDidMount and componentDidUpdate:

  const [count, setCount] = useState(4);

  return (
    <CarouselProvider
      naturalSlideWidth={100}
      naturalSlideHeight={125}
      totalSlides={4}
      dragEnabled={false}
    >
      <Slider>
        <Slide index={0}>
          <div
            style={{
              background:
                "url('https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg'",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
              height: "385px",
            }}
          ></div>
        </Slide>
        <Slide index={1}>
          <div
            style={{
              background:
                "url('https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg'",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "385px",
            }}
          ></div>
        </Slide>
        <Slide index={2}>
          <div
            style={{
              background:
                "url('https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg'",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
              height: "385px",
            }}
          ></div>
        </Slide>
        <Slide index={3}>
          <div
            style={{
              background:
                "url(/assets/images/sidebar-slider-img.jpg) no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
              height: "385px",
            }}
          ></div>
        </Slide>
      </Slider>

      {count <= 1 ? (
        ""
      ) : (
        <div>
          <div className="sidebar-slider-buttons">
            <ButtonBack className="slider-btn back-btn">
              <i className="fa fa-angle-left"></i>
            </ButtonBack>
            <ButtonNext className="slider-btn next-btn">
              <i className="fa fa-angle-right"></i>
            </ButtonNext>
          </div>
          <DotGroup className="sidebar-slider-dots" disabled />
        </div>
      )}
    </CarouselProvider>
  );
};

export default TestSlider;
